// Creates event listener for beforeinstallprompt which is fired when an
// installable PWA is detected. Stores this prompt event in the window for later use.

export default function captureInstallPrompt() {
  window.addEventListener("beforeinstallprompt", e => {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault()
    // Stash the event so it can be triggered later.
    window.deferredInstallPrompt = e
  })
}


// WEBPACK FOOTER //
// ./assets/common/captureInstallPrompt.js